<template>
  <div id="more">
    <h2>More</h2>
    <div v-if="isLoggedIn">
      
      <p>
        If you need assistance, please reach out to us at <a href="tel:+18336926925">(833) NYC-OWAL</a> (833) 692-6925.
      </p/>
      <p>
      To see and edit confirmed matches, <router-link to="/confirmed">click here</router-link>. Clean data helps ensure a reliable algorithm.
      </p>
      <p>
        Face not showing up? <a href="#/more" v-on:click="forceRefresh">Force refresh</a>.
      </p>
      <p>
        <router-link to="/domainselector">Domain and Face Height Selector</router-link>
      </p>
      <p>
        <router-link to="/matched">Faces Matched</router-link> debugging tool
      </p>
      <p>
        <router-link to="/modelvalidator">Model Validator</router-link> debugging tool
      </p>
      <p>
        <router-link to="/faceimages">Face Images</router-link> debugging tool
      </p>
      <p>
        <router-link to="/facesimilarity">Structural Similarity</router-link> debugging tool
      </p>
      <p>
        <router-link to="/clahevalidator">Clahe Validator</router-link> debugging tool
      </p>
    </div>
    <div v-else>
      To start, please <router-link to="/login">log in</router-link>.
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {loadFrontendFaces} from '../util/faces'

export default {
  name: 'more',
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    forceRefresh() {
      loadFrontendFaces()
    }
  }
}
</script>

<style scoped>
#header {
  background-color: #4c4;
}

a:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// More.vue?cfc1927a